import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';

export default [
  {
    path: '/account',
    component: () =>
      interopDefault(
        import(/* webpackChunkName: 'applicant:account' */ '~/pages/account/show.vue')
      ),
    children: [
      {
        path: '',
        name: RouteEnum.ACCOUNT.GENERAL_INFORMATION,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'applicant:account.general-information' */ '~/pages/account/general-information.vue'
            )
          ),
      },
      {
        path: 'documents',
        name: RouteEnum.ACCOUNT.DOCUMENTS.INDEX,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'applicant:account.documents' */ '~/pages/applicant/account/documents/index.vue'
            )
          ),
      },
      {
        path: 'documents/create',
        name: RouteEnum.ACCOUNT.DOCUMENTS.CREATE,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'applicant:account.documents' */ '~/pages/applicant/account/documents/create.vue'
            )
          ),
      },
      {
        path: 'security',
        name: RouteEnum.ACCOUNT.SECURITY,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'applicant:account.security' */ '~/pages/account/security.vue'
            )
          ),
      },
      {
        path: 'danger-zone',
        name: RouteEnum.ACCOUNT.DANGER_ZONE,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'applicant:account.danger-zone' */ '~/pages/account/danger-zone.vue'
            )
          ),
      },
    ],
  },
];
